export const INSERT_RELATIVE_REQUEST = "INSERT_RELATIVE_REQUEST"
export const INSERT_RELATIVES_REQUEST = "INSERT_RELATIVES_REQUEST"
export const INSERT_RELATIVE_SUCCESS = "INSERT_RELATIVE_SUCCESS"
export const INSERT_RELATIVE_ERROR = "INSERT_RELATIVE_ERROR"

export const GET_RELATIVES_REQUEST = "GET_RELATIVES_REQUEST"
export const GET_RELATIVES_SUCCESS = "GET_RELATIVES_SUCCESS"
export const GET_RELATIVES_ERROR = "GET_RELATIVES_ERROR"
export const RESET_RELATIVE_STORE = "RESET_RELATIVE_STORE"
